import React, { useState } from 'react'
import { Link, useStaticQuery, graphql, navigate } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { HiOutlineMenu } from '@react-icons/all-files/hi/HiOutlineMenu'
import { HiOutlineX } from '@react-icons/all-files/hi/HiOutlineX'
import { HiChevronDown } from '@react-icons/all-files/hi/HiChevronDown'

import { BG_IMG_CLASSES } from "../../helpers/utils";

import Button from '../button'

const MENU = [
    { name: 'Web3 Solutions', menu: [
        { link: '/blog/utility-as-a-service/', name: 'Utility-as-a-Service', subheading: 'Deliver unparalleled utility to your community in just a few clicks' },
        { link: '/non-fungible-vault/', name: 'Non-Fungible Vault', subheading: 'Long-term preservation of NFTs inside the Arctic World Archive' },
    ]},
    { name: 'Our Collections', menu: [
        { link: 'https://topdogbeachclub.com', name: 'Top Dogs', subheading: 'Our genesis collection of 7,500 dog NFTs' },
        { link: 'https://topcatbeachclub.com', name: 'Top Cats', subheading: 'Our second collection of 6,900 cat NFTs' },
        { link: '/get-loud-for-girls/', name: 'Get Loud For Girls', subheading: 'Our charity collection raising funds for girls charity She\'s the First' }
    ]},
    // { link: '/team/', name: 'Our Story', title: "Meet the team!" },
    { link: '/blog/', name: 'Blog', title: "Regular updates and insights from the team", menu: [] },
    { link: '/#contact', name: 'Contact' }
]

const NavPill = ({ link, subMenu, title, className, data, children }) => {
    const hasSubNav = subMenu && subMenu !== 'undefined';
    const linkClasses = `
        tracking-tight inline-flex px-4 py-2
        no-underline text-white mr-2 text-lg
        font-bold hover:bg-gray-100 hover:text-gray-900
        group-hover:bg-gray-100 group-hover:text-black
        ${className}
        ${hasSubNav ? "cursor-text rounded-t-lg hover:rounded-b-none" : "cursor-pointer rounded-full"}
    `
    
    return (
        <div className="group inline-block">
            {link
                ?
                    <Link
                        to={link}
                        className={linkClasses}
                        activeClassName="!text-white bg-black"
                        title={title}
                        partiallyActive={link == '/gallery/' || link == '/blog/'}
                    >
                        {children}
                    </Link>
                :
                <span
                    className={linkClasses}
                    title={title}
                >
                    {children}
                    {hasSubNav && <HiChevronDown className="ml-1 mt-1" />}
                </span>
            }

            {hasSubNav && <div className="group-hover:block absolute hidden w-screen left-0 bg-gray-100 shadow-lg">
                <nav className="contained grid gap-4 p-8 grid-cols-3">
                    {subMenu.length > 0 && subMenu.map((menuItem, index) => (
                        <NavPill
                            key={index}
                            link={menuItem.link}
                            subMenu={menuItem.menu}
                            className="flex flex-col mb-2 !p-6 !text-black hover:!bg-white !rounded-sm hover:!shadow-sm"
                        >
                            <p className="mb-1">{menuItem.name}</p>
                            <span className="text-xs font-light text-gray-700">{menuItem.subheading}</span>
                        </NavPill>
                    ))}
                </nav>
                {data &&
                    <div className="contained h-60">
                        <p className="text-gray-800 font-bold uppercase text-xs mb-2">Recent blog posts</p>

                        <div className="flex overflow-x-auto space-x-6 h-56">
                            {data.map(({ node: item }, index) => {
                                const image = getImage(item.frontmatter.image);
                    
                                return <div
                                    key={index}
                                    className="flex-shrink-0 h-32 w-48 hover:cursor-pointer"
                                    onClick={() => navigate(item.fields.slug)}
                                    >
                                    <div className="grid">
                                        <GatsbyImage
                                            image={image}
                                            alt={item.frontmatter.title}
                                            className={`opacity-75`}
                                            loading="eager"
                                            style={{ gridArea: "1/1" }}
                                        />

                                        <div
                                            className="grid z-10 bg-black bg-opacity-50 p-4"
                                            style={{ gridArea: '1/1' }}
                                        >
                                            <p className="text-sm uppercase font-bold">{item.frontmatter.title}</p>
                                            <p className="place-self-end text-xs uppercase text-gray-300">{item.frontmatter.date}</p>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                }
            </div>}
        </div>
    )
}

const BurgerButton = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => (
    <Button
        action={ (e) => setIsMobileMenuOpen(!isMobileMenuOpen) }
        theme="outline"
        icon={isMobileMenuOpen ? HiOutlineX : HiOutlineMenu}
        aria-controls="mobile-menu"
        aria-expanded="false"
    />
)

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const { allMarkdownRemark: data } = useStaticQuery(graphql`
        query {
            allMarkdownRemark (
                filter: {
                    frontmatter: { visible: { ne: false } }
                    fields: { collection: { eq: "blog" } }
                }
                sort: { fields: [frontmatter___date], order: DESC }
            ) {
                edges {
                    node {
                    fields {
                        slug
                    }
                    frontmatter {
                        date(formatString: "MMMM D, YYYY")
                        title
                        image {
                            childImageSharp {
                                gatsbyImageData(
                                    width: 200,
                                    height: 200,
                                    quality: 90,
                                    layout: FIXED
                                )
                            }
                        }
                    }
                }
            }
        }
    }`);

    return (
        <>
            {!isMobileMenuOpen &&
                <nav className="hidden lg:block bg-black rounded-full shadow-lg py-2 px-4 bg-opacity-75">
                    {MENU.map((menuItem, index) =>
                        <NavPill
                            key={index}
                            link={menuItem.link}
                            title={menuItem.title}
                            subMenu={menuItem.menu}
                            data={menuItem.name === 'Blog' ? data.edges : null}
                        >
                            {menuItem.name}
                    </NavPill>)}
                </nav>
            }

            <div className="absolute inset-y-0 right-0 flex items-center lg:hidden mr-3">
                <BurgerButton isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />
            </div>

            {isMobileMenuOpen &&
                <div className="fixed inset-0 overflow-y-auto bg-black">
                    <div className="flex items-end justify-center min-h-screen px-4 pb-32 sm:block sm:p-0">
                        <div className="fixed inset-0 transition-opacity p-8" aria-hidden="true">
                            <div className="flex items-center justify-end">
                                <BurgerButton isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />
                            </div>
                        </div>

                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                        <div className="inline-block align-bottom transform transition-all sm:mx-6 sm:my-32 sm:align-top">
                            {MENU.map((menuItem, index) =>
                                <div className="md:mb-2">
                                    <Link to={menuItem.link} className="text-white text-4xl leading-normal">{menuItem.name}</Link>

                                    {menuItem.menu && <div className="ml-4">
                                        {menuItem.menu.map((subMenuItem, index) => <Link to={subMenuItem.link} className="text-white block">{subMenuItem.name}</Link>)}
                                    </div>}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default Navigation